import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useCart } from '../../context/CartContext';
import SafeIcon from '../../common/SafeIcon';
import { FiCheckCircle } from 'react-icons/fi';

export default function Toast() {
  const { notification } = useCart();

  return (
    <AnimatePresence>
      {notification && (
        <motion.div 
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[100] bg-bloom-charcoal text-white px-6 py-3 rounded-2xl shadow-2xl flex items-center gap-3 whitespace-nowrap border border-white/10"
        >
          <SafeIcon icon={FiCheckCircle} className="text-bloom-mint text-xl" />
          <span className="font-bold text-sm">{notification}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}